<template>
  <div class="modal fade" id="change-plant-growth-phase" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="modal-block-vcenter" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header" :class="[headerColor]">
            <h3 class="block-title"><i class="fa fa fa-exchange-alt"></i> Change growth phase</h3>
            <div class="block-options">
              <button type="button" class="btn-block-option" data-dismiss="modal" aria-label="Close" @click.prevent="clearData()">
                <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <transition name="slide-fade">
            <div class="text-center alert-message-top" v-if="errorMsg">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="alert-message alert-danger alert-error-message">{{ errorMsg }}</div>
              </div>
            </div>
          </transition>
          <div class="block-content">
            <div class="form-group required">
              <label class="control-label">Id</label>
              <input name="plantId" type="text" v-model="id" v-validate="'required'" data-vv-as="Plant ID" class="form-control form-control-alt" placeholder="Plant Id" />
              <p v-if="errors.has('plantId')" class="errorMsg">{{ errors.first('plantId') }}</p>
            </div>
            <div class="form-group">
              <label>Plant Label</label>
              <input name="plantLabel" type="text" v-model="label" class="form-control form-control-alt" placeholder="Plant label" />
            </div>
            <div class="form-group required">
              <label class="control-label">New Tag</label>
              <input name="newTag" type="text" v-model="newTag" v-validate="'required'" data-vv-as="New Tag" class="form-control form-control-alt" placeholder="Add New Tag" />
              <p v-if="errors.has('newTag')" class="errorMsg">{{ errors.first('newTag') }}</p>
            </div>
            <div class="form-group required">
              <label class="control-label">Growth Phase</label>
              <select id="v-plant-phase" class="form-control form-control-alt v-plant-select2-dropdown" placeholder="Select GrowthPhase.." style="width: 100%">
                <option></option>
                <option :value="phase" v-for="(phase, index) in library.growthPhases" v-bind:selected="growthPhase == phase" :key="index">{{ phase }}</option>
              </select>
              <p v-if="phaseError" class="errorMsg">The Growthphase field is required.</p>
            </div>
            <div class="form-group required">
              <label class="control-label">New Room</label>
              <select id="v-plant-room" class="form-control form-control-alt v-plant-select2-dropdown" placeholder="Select Room.." style="width: 100%">
                <option></option>
                <option :value="room.Name" v-for="(room, index) in library.rooms" v-bind:selected="newRoom == room.Name" :key="index">{{ room.Name }}</option>
              </select>
              <p v-if="roomError" class="errorMsg">The Room field is required.</p>
            </div>
            <div class="form-group">
              <label>Growth Date</label>
              <input v-model="actualDate" id="v-plant-datepicker" type="text" class="form-control form-control-alt" placeholder="Date" />
            </div>
          </div>
          <div class="block-content block-content-full text-right border-top button-loader">
            <button type="button" class="btn btn-sm btn-light" data-dismiss="modal" @click.prevent="clearData()">Close</button>
            <button type="button" class="btn btn-sm btn-primary" @click.prevent="changeGrowthPhase()" :bind:disabled="showModalLoader">
              <div><i class="fa fa-save mr-1"></i>Save</div>
              <span class="modal-loader" v-if="showModalLoader">
                <hash-loader class="custom-class text-white" color="#fff" loading="loading" size="15" sizeUnit="px"></hash-loader>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import { mapState, mapActions } from 'vuex';
import { VueSpinners, HashLoader } from '@saeris/vue-spinners';
import { helper } from '@/helper.js';
import $ from 'jquery';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
Vue.use(VeeValidate, VueSpinners);

export default {
  name: 'ChangePlantGrowthPhase',
  data() {
    return {
      id: 0,
      label: '',
      newTag: '',
      growthPhase: '',
      newRoom: '',
      actualDate: new Date().toJSON().slice(0,10),
      errorMsg: '',
      showModalLoader: false,
      roomError: false,
      phaseError: false,
      headerColor: 'bg-info'
    };
  },
  components: {
    HashLoader
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  },
  mounted() {
    let vm = this;
    $('#v-plant-room').on('change', function() {
      vm.newRoom = $(this).val(); vm.roomError = false;
    });
    $('#v-plant-phase').on('change', function() {
      vm.growthPhase = $(this).val(); vm.phaseError = false;
    });
    let datePicker = $('#v-plant-datepicker').datepicker(
      { format: 'yyyy-mm-dd', autoclose: true }
    );
    datePicker.on('changeDate', (e) => {
      vm.actualDate = e.format();
    });
  },
  methods: {
    ...mapActions('library', ['getAllFloweringPlants', 'getAllVegetativePlants']),
    clearData() {
      this.id = '';
      this.label = '';
      this.newTag = '';
      this.growthPhase = '';
      this.newRoom = '';
      this.errorMsg = '';
      this.actualDate = new Date().toJSON().slice(0,10);
      $('.v-plant-select2-dropdown').val(null).trigger('change');
      $('#v-plant-datepicker').datepicker('update', this.actualDate);
      this.$validator.reset();
    },
    setPlantDetails(plant, bgColor) {
      this.id = plant.Id;
      this.label = plant.Label;
      this.headerColor = bgColor;
      this.growthPhase = plant.GrowthPhase;
      this.newRoom = plant.RoomName;
      $('#v-plant-room').val(plant.RoomName).trigger('change');
      $('#v-plant-phase').val(plant.GrowthPhase).trigger('change'); 
    },
    changeGrowthPhase() {
      let vm = this;
      this.$validator.validate().then(valid => {
        if (vm.validate() && valid) {
          vm.showModalLoader = true;
          vm.errorMsg = '';
          helper.sendPostRequest(
            '/plants/changegrowthphases',
            {
              Id: this.id,
              Label: this.label,
              NewTag: this.newTag,
              GrowthPhase: this.growthPhase,
              NewRoom: this.newRoom,
              GrowthDate: this.actualDate
            }
          ).then((data) => {
            if (data.status === 'success') {
              vm.showModalLoader = false;
              vm.getAllVegetativePlants();
              vm.getAllFloweringPlants();
              jQuery('#change-plant-growth-phase').modal('hide');
              vm.clearData();
              helper.showSuccessModal(data.message);
            } else {
              vm.errorMsg = data.message;
              vm.showModalLoader = false;
            }
          });
        }
      });
    },
    validate() {
      if (!this.newRoom) {
        this.roomError = true;
      }

      if (!this.growthPhase) {
        this.phaseError = true;
      }

      if (this.phaseError || this.roomError) {
        return false;
      }
      return true;
    }
  }
};
</script>


// WEBPACK FOOTER //
// source/components/modals/ChangePlantGrowthPhase.vue